import React from "react";

export default function PlansModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const plans = [
    {
      title: "Basic",
      price: "$0/month",
      features: ["1 product", "No support", "Limited features"],
    },
    {
      title: "Pro",
      price: "$9.99/month",
      features: ["10 products", "Email support", "Advanced tools"],
    },
    {
      title: "Premium",
      price: "$29.99/month",
      features: ["Unlimited products", "Priority support", "All features"],
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-3xl shadow-lg mx-auto overflow-y-auto max-h-[90vh]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Choose Your Plan</h2>
          <button 
            onClick={onClose} 
            className="text-gray-500 hover:text-black text-2xl leading-none"
          >
            &times;
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
          {plans.map((plan, index) => (
            <div 
              key={index} 
              className="border rounded-lg p-4 shadow hover:shadow-md transition flex flex-col"
            >
              <div className="flex-grow">
                <h3 className="text-lg font-bold mb-2">{plan.title}</h3>
                <p className="text-sm text-gray-600 mb-3">{plan.price}</p>
                <ul className="mb-4 text-sm text-gray-700 list-disc pl-5 space-y-1">
                  {plan.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
              <button className="w-full bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition mt-auto">
                Choose {plan.title}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}